import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './help.component'

let module = angular.module('help', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject'
  $stateProvider
    .state('help', {
      url: '/help?token',
      component: 'help',
      authenticate: true
    })
})
.component('help', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/help/index.js